import { TooltipFormatterContextObject } from 'highcharts';
import { formatNumber, truncateText } from '../utils/format.helper';
import { getUtcDate } from '../utils/date-helper';

export function renderTooltip(
  this: any,
  dataType?: string,
  formatDate: string | undefined = 'DD/MM/YYYY',
  useSeriesName: boolean = false,
  useYPointValue: boolean = false // this fix tooltip for charts like fii/stocks, that need to show the point value
) {
  // @ts-ignore
  const { points, x: date }: TooltipFormatterContextObject = this;

  const sortedPoints = sortSeriesByValue(points as any)
    ?.sort((a, b) => {
      // @ts-ignore
      const value1 = a?.point?.change !== undefined ? a?.point?.change : a.y;
      // @ts-ignore
      const value2 = b?.point?.change !== undefined ? b?.point?.change : b.y;

      return value2 - value1;
    })
    .map((point: any) => {
      const value = useYPointValue
        ? point.y
        : point?.point?.change !== undefined
        ? point?.point?.change
        : point.y;

      let renderValue = '';
      const color = point?.color?.substring(0, 7);

      switch (dataType) {
        case 'money':
          renderValue = formatNumber(value, {
            type: 'money',
            thousandMask: true,
            hideZero: true,
            useNullPlaceholder: false,
          });
          break;
        case 'percent':
          renderValue = formatNumber(value, {
            type: 'percent',
            useNullPlaceholder: false,
          });
          break;
        default:
          renderValue = formatNumber(parseInt(value), {
            thousandMask: true,
            useNullPlaceholder: false,
          });
          break;
      }

      return `
      <tr style="font-weight: bold; color: ${color}">
        <td style="border-left: 5px solid ${color}; padding-left: 6px">${renderValue}</td>
        <td style="padding-bottom: 3px"> |  ${truncateText(
          point.series.name,
          25
        )}</td>
      </tr>
      `;
    })
    .join('');

  return `
  <span style="font-weight: bold; padding-top: 6px">${
    useSeriesName ? this.key : getUtcDate(date as any, formatDate)
  }</span>
  <hr />
  <table>
    ${sortedPoints}
  </table>
  `;
}

const sortSeriesByValue = (
  points: Array<TooltipFormatterContextObject>
): Array<TooltipFormatterContextObject> => {
  return points?.sort((point1: any, point2: any) => point2.y - point1.y);
};

export const hasSelected = (benchmark: string, list: string[]): boolean =>
  !list.find((b) => b === benchmark);
